module.exports = __webpack_public_path__ + "a4b9677c.jpg";